import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { OfficeBase } from './office.base';

export const OfficeAutomation = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.AUTOMATION);
const config = OfficeAutomation;
config.extend(OfficeBase);

OfficeAutomation.set('config.key', 'arn:aws:kms:us-east-1:487538251179:key/af5e8a86-6d0f-4f02-b7fa-080e081ba0c8');
OfficeAutomation.set('config.store', 'automation');
OfficeAutomation.set('vendor.google.maps', 'AIzaSyA_j7Kpx-R8dPxO29kD6Id0EX724Yj_vZc');
OfficeAutomation.set('vendor.google.analytics', 'UA-73934200-1');
OfficeAutomation.set('vendor.google.tagmanager', 'GTM-5BZ5NZJ');
OfficeAutomation.set('vendor.google.mapsReleaseChannel', 'weekly');
